module.exports = __webpack_public_path__ + "img/feature.32c93ac9.png";